export const nl = {
  title: 'Boom bedekking',
  subtitle: 'https://glad.umd.edu/dataset/global-2010-tree-cover-30-m',
  download_data: 'http://science.sciencemag.org/content/342/6160/850',
  learn_more: 'http://science.sciencemag.org/content/342/6160/850',
  content: [
    {
      label: 'Functie',
      value: 'Identificeert gebieden met boombedekking',
    },
    {
      label: 'Resolutie',
      value: '30 × 30 meter',
    },
    {
      label: 'Geografische dekking',
      value: 'Wereldwijd land (exclusief Antarctica en Arctische eilanden)',
    },
    {
      label: 'Bron',
      value:
        'Hansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice en J. R. G. Townshend. 2013. "Wereldwijde kaarten met hoge resolutie van de verandering van bosbedekking in de 21e eeuw." Wetenschap 342 (15 november): 850-53. Gegevens beschikbaar bij: https://glad.umd.edu/dataset/global-2010-tree-cover-30-m.',
    },
    {
      label: 'Frequentie',
      value: '',
    },
    {
      label: 'Datum van inhoud',
      value: '2000 & 2010',
    },
    {
      label: 'Waarschuwingen',
      value:
        'Voor het doel van deze studie werd "boombedekking" gedefinieerd als alle vegetatie hoger dan 5 meter hoog. "Boombedekking" is de biofysische aanwezigheid van bomen en kan de vorm aannemen van natuurlijke bossen of plantages die bestaan over een reeks van luifeldichtheden.',
    },
    {
      label: 'Licentie',
      value: 'CC DOOR 4.0',
    },
  ],
  overview: {
    label: 'Overzicht',
    value:
      'Deze dataset, een samenwerking tussen het GLAD-lab (Global Land Analysis & Discovery) van de Universiteit van Maryland, Google, USGS en NASA, toont de boombedekking over al het land ter wereld (behalve Antarctica en een aantal Arctische eilanden) voor de jaren 2000 en 2010 met een resolutie van 30 × 30 meter. "Percentage boombedekking" wordt gedefinieerd als de dichtheid van de bedekking van het bladerdak van het landoppervlak en wordt gekleurd door dichtheidsbeugel (zie legenda).\n\nGegevens in deze laag werden gegenereerd met behulp van multispectrale satellietbeelden van de Landsat 7 thematische mapper plus (ETM+) sensor. De waarnemingen van het heldere oppervlak van meer dan 600.000 afbeeldingen werden geanalyseerd met behulp van Google Earth Engine, een cloudplatform voor aardobservatie en gegevensanalyse, om de boombedekking per pixel te bepalen met behulp van een algoritme voor begeleid leren.\n\nDe dichtheid van het bladerdak van de weergegeven gegevens varieert afhankelijk van de selectie - gebruik de legenda op de kaart om de drempelwaarde voor de minimale dichtheid van het bladerdak van bomen te wijzigen.',
  },
  citation: {
    label: 'Aanhaling',
    value:
      'Use the following credit when these data are displayed:\nSource: Hansen/UMD/Google/USGS/NASA, accessed through Global Forest Watch\n\nUse the following credit when these data are cited:\nHansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from:https://glad.umd.edu/dataset/global-2010-tree-cover-30-m. Accessed through Global Forest Watch on 11/02/2025. www.globalforestwatch.org',
  },
};
